<div
    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mb-0dot5 cmps-cdk-px-1"
>
    <ng-container *ngIf="_state.phase?.live === true">
        <div
            class="cmps-cdk-cursor-pointer"
            (click)="_onCheckClick()"
        >
            <cmps-icon
                class="cmps-cdk-fill-blue-100"
                svgIcon="check-circle"
                *ngIf="area?.evaluatedBool === true"
            ></cmps-icon>
            <cmps-icon
                class="cmps-cdk-fill-grey-400"
                svgIcon="circle-outline"
                *ngIf="area?.evaluatedBool !== true"
            ></cmps-icon>
        </div>
        <div
            class="cmps-cdk-font-bold cmps-cdk-font-size-16p cmps-cdk-cursor-pointer cmps-cdk-pl-0dot5"
            (click)="_onCheckClick()"
        >
            {{ area?.label }}
        </div>
    </ng-container>
    <ng-container *ngIf="_state.phase?.live !== true">
        <div class="cmps-cdk-font-bold cmps-cdk-font-size-16p">
            {{ area?.label }}
        </div>
    </ng-container>
    <div class="cmps-cdk-flex-grow-1"></div>
    <div>
        <cmps-ca-evaluation-focus-actions
            [group]="group"
            [area]="area"
        ></cmps-ca-evaluation-focus-actions>
    </div>
</div>
<div class="cmps-cdk-pl-2 cmps-cdk-pr-1">
    <div
        class="cmps-cdk-mb-0dot5"
        *ngIf="!area?.collapsedProTips && area?.proTips?.length > 0"
    >
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-unknown-107 cmps-cdk-border-radius-8p cmps-cdk-px-0dot75 cmps-cdk-py-0dot5 cmps-cdk-bg-color-unknown-100"
        >
            <ul class="cmps-cdk-mb-0 cmps-cdk-pl-1">
                <li *ngFor="let pt of area?.proTips">
                    {{ pt }}
                </li>
            </ul>
        </div>
    </div>
    <ng-container *ngIf="_state.phase?.live !== true">
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-mb-0dot5"
            *ngIf="area?.phrase == null"
        >
            <div>
                <button
                    type="button"
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-border-radius-4px cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-min-h-24p cmps-cdk-px-0dot75 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center focus:not:focus-visible:cmps-cdk-outline-0 cmps-cdk-bg-color-white cmps-cdk-border-color-unknown-107 cmps-cdk-color-unknown-122 hover:cmps-cdk-bg-color-unknown-103 hover:cmps-cdk-border-color-unknown-105 hover:cmps-cdk-color-unknown-104"
                    (click)="_showIcaPhrases = !_showIcaPhrases"
                >
                    <cmps-icon
                        class="cmps-cdk-w-16px nested:cmps-cdk-w-inherit"
                        svgIcon="chat-processing-outline"
                    ></cmps-icon>
                    <span class="cmps-cdk-line-clamp-1">4 ICA suggestions</span>
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-border-radius-4px cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-min-h-24p cmps-cdk-px-0dot75 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center focus:not:focus-visible:cmps-cdk-outline-0 cmps-cdk-bg-color-white cmps-cdk-border-color-unknown-107 cmps-cdk-color-unknown-122 hover:cmps-cdk-bg-color-unknown-103 hover:cmps-cdk-border-color-unknown-105 hover:cmps-cdk-color-unknown-104"
                    (click)="_onAddMyPhraseClick(ref)"
                >
                    <cmps-icon
                        class="cmps-cdk-w-16px nested:cmps-cdk-w-inherit"
                        svgIcon="plus"
                    ></cmps-icon>
                    <span class="cmps-cdk-line-clamp-1">Add my Phrase</span>
                </button>
            </div>
        </div>
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-unknown-107 cmps-cdk-border-radius-10px cmps-cdk-bg-color-white cmps-cdk-overflow-hidden"
            *ngIf="_showIcaPhrases === true"
        >
            <div *ngFor="let p of _icaPhrases; let l = last">
                <button
                    type="button"
                    class="cmps-cdk-bg-color-white cmps-cdk-border-width-0p cmps-cdk-px-0dot75 cmps-cdk-py-0dot5 cmps-cdk-text-left hover:cmps-cdk-bg-color-unknown-116 cmps-cdk-cursor-pointer cmps-cdk-w-100pct focus:not:focus-visible:cmps-cdk-outline-0"
                    (click)="_onIcaPhraseClick(p)"
                >
                    <span class="cmps-cdk-d-block">"{{ p[0] }}"</span>
                    <span
                        class="cmps-cdk-font-bold cmps-cdk-border-radius-4px cmps-cdk-py-0dot25 cmps-cdk-px-0dot5 cmps-cdk-bg-color-unknown-114 cmps-cdk-color-unknown-122 cmps-cdk-font-size-9p"
                        >{{ p[1] }}</span
                    >
                </button>
                <div
                    class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-unknown-107 cmps-cdk-h-1px"
                    *ngIf="!l"
                ></div>
            </div>
        </div>
        <div #ref></div>
    </ng-container>
    <div *ngIf="area?.phrase != null">
        <cmps-ca-evaluation-phrase
            [group]="group"
            [area]="area"
        ></cmps-ca-evaluation-phrase>
    </div>
</div>
